
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Ejecutivo } from '../interfaces/ejecutivo';
import { Paso3 } from '../interfaces/paso-3';
import { LocalStorageService } from './localstorage.service';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    public ejecutivo: Ejecutivo;
    
    private rubroSeleccionadoSource = new BehaviorSubject<any>(null);
    public rubroSeleccionado$ = this.rubroSeleccionadoSource.asObservable();

    constructor(
        protected localStorageService: LocalStorageService
    ) { }

    getEjecutivo() {
        if (this.ejecutivo == null) {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has(environment.urlQueryParam.ejecutivoParamName)) {
                const decoded = atob(urlParams.get(environment.urlQueryParam.ejecutivoParamName));
                let ejecutivo: Ejecutivo = JSON.parse(decoded) as Ejecutivo;
                if (ejecutivo != null) {
                    this.ejecutivo = ejecutivo;
                }
            }
        }
        return this.ejecutivo;
    }

    setRubroSeleccionado(data: any): void {
        this.rubroSeleccionadoSource.next(data);
    }

    getRubroSeleccionado() {
        if (this.rubroSeleccionadoSource.getValue() == null) {
            let step3Data: Paso3 = this.localStorageService.getPaso3();
            if (step3Data && step3Data.datosComercio && step3Data.datosComercio.actividadEconomica) {
                this.setRubroSeleccionado(Array.isArray(step3Data.datosComercio.actividadEconomica.relacion) && step3Data.datosComercio.actividadEconomica.relacion.length > 0 ? step3Data.datosComercio.actividadEconomica.relacion[0] : null);
            }
        }
        return this.rubroSeleccionadoSource.getValue();
    }
}